import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import { Link } from 'react-router-dom';
import CardActionArea from '@mui/material/CardActionArea';
import CircularProgress from '@mui/material/CircularProgress';
import useRoutes from '../../../../../components/_hook/useRoutes';
import { useCompanyQuery } from '../../../../../../graphql/query/company/useCompanyQuery';
import ProductLayout from '../../../../../layout/Product';
import NotFound from '../../../../../components/_error/NotFound';
import Context from '../../../../../context';
import Helmet from '../../../../../components/Helmet';

function DropshipperOverview() {
  const { t } = useTranslation();
  const { company } = useContext(Context);
  const { path } = useRoutes();
  const { data, loading } = useCompanyQuery(
    `
    _id
    statistic {
      dropshipper {
        approved
        disapproved
        pending
      }
    }
  `,
    {
      variables: {
        filter: {
          _id: company._id as string,
        },
        limit: 1,
      },
    }
  );

  const queryCompany = data ? data.companies.items[0] : null;

  if (loading) return <CircularProgress color="primary" />;
  if (!queryCompany) return <NotFound />;
  const statistic =
    queryCompany && queryCompany.statistic ? queryCompany.statistic : null;
  const dropshipperStatistic =
    statistic && statistic.dropshipper ? statistic.dropshipper : null;
  return (
    <>
      <Helmet title={`${t('dropshipper_overview')} | ${t('product')}`} />
      <Grid container spacing={2}>
        <Grid item xs={12} container justifyContent="center" spacing={1}>
          <Grid item xs={12}>
            <Typography variant="h4" align="center" gutterBottom>
              {t('dropshipper_overview')}
            </Typography>
          </Grid>
          <Grid item xs={12} container justifyContent="center" spacing={1}>
            <Grid item xs={12} sm={6} md={3}>
              <Card>
                <CardActionArea
                  component={Link}
                  to={path('product.dropshipping.dropshipper.approved', {
                    companyID: queryCompany._id,
                  })}
                >
                  <CardContent>
                    <Typography variant="h6" align="center" gutterBottom>
                      {t('approved')}
                    </Typography>
                    <br />
                    <Typography variant="h4" align="center" color="primary">
                      {dropshipperStatistic && dropshipperStatistic.approved
                        ? dropshipperStatistic.approved
                        : 0}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card>
                <CardActionArea
                  component={Link}
                  to={path('product.dropshipping.dropshipper.disapproved', {
                    companyID: queryCompany._id,
                  })}
                >
                  <CardContent>
                    <Typography variant="h6" align="center" gutterBottom>
                      {t('disapproved')}
                    </Typography>
                    <br />
                    <Typography variant="h4" align="center" color="primary">
                      {dropshipperStatistic && dropshipperStatistic.disapproved
                        ? dropshipperStatistic.disapproved
                        : 0}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card>
                <CardActionArea
                  component={Link}
                  to={path('product.dropshipping.dropshipper.pending', {
                    companyID: queryCompany._id,
                  })}
                >
                  <CardContent>
                    <Typography variant="h6" align="center" gutterBottom>
                      {t('pending')}
                    </Typography>
                    <br />
                    <Typography variant="h4" align="center" color="primary">
                      {dropshipperStatistic && dropshipperStatistic.pending
                        ? dropshipperStatistic.pending
                        : 0}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default () => <ProductLayout main={<DropshipperOverview />} />;
